import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { storeQueryOptions } from '@/features/stores';
import { TaxPage, taxRatesQueryOptions } from '@/features/tax';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/tax')({
  staticData: { crumb: 'common:nav.tax', tours: ['settings.tax'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'settings.read');
  },
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient
        .query({ ...storeQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
      context.queryClient
        .query({ ...taxRatesQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
    ]),
  component: TaxPage,
});
